import script from "./ai-text-generator-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ai-text-generator-modal.vue?vue&type=script&setup=true&lang=ts"

import "./ai-text-generator-modal.vue?vue&type=style&index=0&id=6be8b56a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be8b56a"]])

export default __exports__